module.exports = __webpack_public_path__ + "img/header_profile.f73d18ab.png";